import { ILogger, resolve } from 'aurelia';


export class TripApi {
    log = resolve(ILogger).scopeTo('app.TripApi');
    aurelia_options = aurelia_options;

    constructor() {}

    /** Tiny wrapper around fetch that combines error throws for network error, 4xx/5xx response and json parse errors. */
    async fetchjson(url, fetchOptions) {
        fetchOptions.headers = {
            ...fetchOptions.headers,
            'Content-Type': 'application/json;charset=UTF-8',
            'Accept': 'application/json'
        };
        let awaitedResponse = await fetch(url, fetchOptions);
        if (! awaitedResponse.ok) {
            throw new Error(`HTTP error! Status: ${awaitedResponse.status}`)
        }
        return await awaitedResponse.json();
    }

    getTripPackagegroupItems(packagegroup_id, searchParameters) {
        let url = this.aurelia_options.last_minute_trips_api_location + "get_packagegroupitems?packagegroup_id=" + packagegroup_id;
        url = url + "&price_min=" + searchParameters.priceRangeSelection.min;
        if (searchParameters.priceRangeSelection.max != 3000) {
            url = url + "&price_max=" + searchParameters.priceRangeSelection.max;
        }
        if (searchParameters.tagSelection) {
            url = url + "&hotel_tag=" + searchParameters.tagSelection;
        }
        url = url + "&hotelrating_min=" + searchParameters.hotelRatingSelection;
        url = url + "&mealplan_min=" + searchParameters.mealplanSelection;
        url = url + "&lang=" + this.aurelia_options.language;

        return this.fetchjson(url, {});
    }

    async getFilterData(language) {
        let url = aurelia_options.last_minute_trips_api_location + "filterdata?";

        url = url + "lang=" + aurelia_options.language;
        this.log.debug(url);

        return await this.fetchjson(url, { cache: "no-store" });;
    }

    toUrl(searchParameters, responseShouldIncludePagination) {
        let out = {};

        // out.offset = searchParameters.pagination.pageSize * (searchParameters.pagination.pageNumber - 1);
        // out.limit = searchParameters.pagination.pageSize;
        out.get = responseShouldIncludePagination ? "total" : undefined;

        let defaultDatestr = new Date(Date.now() + 60 * 60 * 24 * 1000).toISOString().substring(0, 10);
        out.departure_date = searchParameters.dateSelection != defaultDatestr ? searchParameters.dateSelection : undefined;
        out.nights_min = searchParameters.durationSelection != 0 ? searchParameters.durationSelection : undefined;
        out.price_min = searchParameters.priceRangeSelection.min != 0 ? searchParameters.priceRangeSelection.min : undefined;
        out.price_max = searchParameters.priceRangeSelection.max != 3000 ? searchParameters.priceRangeSelection.max : undefined;
        out.hotelrating_min = searchParameters.hotelRatingSelection != 0 ? searchParameters.hotelRatingSelection : undefined;
        out.mealplan_min = searchParameters.mealplanSelection != 0 ? searchParameters.mealplanSelection : undefined;
        out.departure_city = searchParameters.departureSelection != 0 ? searchParameters.departureSelection : undefined;
        // when a whole country is selected, selection also contains every one of its resorts - drop those, only the country is needed
        let destinationSelection = searchParameters.destinationSelection.filter(x =>
            x === x.split('_')[0] || !searchParameters.destinationSelection.includes(x.split('_')[0])
        );
        out.destination = destinationSelection.length ? destinationSelection.join('|') : undefined;
        out.hotel_tag = searchParameters.tagSelection != "" ? searchParameters.tagSelection : undefined;
        
        out.sort_order = searchParameters.sortOrder != 'departure-up' ? searchParameters.sortOrder : undefined;
        out.hotel_name = searchParameters.hotelInfoParams.hotelName !== "" ? searchParameters.hotelInfoParams.hotelName : undefined;
        
        return out;
    }

}
